import { swalMessages } from '@auteco/constants'
import React, { useState, useEffect , useContext } from 'react'

import ConfigPage from 'src/pages/GvcPage/ConfigPage/ConfigPage'
import {
  getPartnersConfig,
  getBosses,
  getRegions,
  createPartner,
  updatePartner,
  getGroupList,
} from 'src/services/GvcServices'
import swal from 'sweetalert'
import { Context } from '../../context/Contex'

const ConfigContainer = () => {
  const [partnersConfig, setPartnersConfig] = useState([])
  const [bosses, setBosses] = useState([])
  const [regions, setRegions] = useState([])
  const [groupList, setGroupList] = useState([])

  const { unidad } = useContext(Context)


  const fetchPartnersConfig = async () => {
    const { success, data } = await getPartnersConfig()
    if (success) {
      setPartnersConfig(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const fetchBosses = async () => {
    const { success, data } = await getBosses()
    if (success) {
      setBosses(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const fetchRegions = async () => {
    const { success, data } = await getRegions(unidad)
    if (success) {
      setRegions(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const fetchGroupList = async () => {
    const { success, data } = await getGroupList()
    if (success) {
      setGroupList(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const handleSaveInformation = async (params) => {
    const body = {
      id: params.id,
      codSap: params.codSap,
      razonSocial: params.razonSocial,
      idJefe: params.idJefe,
      estado: params.estado,
      idTerritorio: params.idTerritorio,
      idGrupo: params.idGrupo
    }

    const selectServices = () =>
      params.id ? updatePartner(body) : createPartner(body)

    const { data } = await selectServices()
    setPartnersConfig(data)
  }

  useEffect(() => {
    fetchPartnersConfig()
    fetchBosses()
    fetchRegions()
    fetchGroupList()
  }, [])

  return (
    <ConfigPage
      handleSaveInformation={handleSaveInformation}
      partners={partnersConfig}
      bosses={bosses}
      regions={regions}
      groupList={groupList}
    />
  )
}

export default ConfigContainer
